import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { OfferModalsHeaderComponent } from '../offer-header/offer-modals-header.component';
import { ModalCloseComponent } from '../modal-close/modal-close.component';

@Component({
    selector: 'app-action-error',
    templateUrl: './action-error.component.html',
    styleUrls: ['./action-error.component.scss'],
    imports: [OfferModalsHeaderComponent, ModalCloseComponent]
})
export class ActionErrorComponent implements AfterViewInit {
  @Input() errorText: string;
  @Input() tenantName: string;
  @Output() close = new EventEmitter<void>();
  @ViewChild('heading') heading: ElementRef<HTMLElement>;
  closeModal() {
    this.close.emit();
  }

  ngAfterViewInit(): void {
    this.heading.nativeElement.focus();
  }
}
